<template>
  <div v-frag class="prism-elite-app">
    <!-- Main Content (v-if="!mantenimiento") -->
    <CardIeaAppMain colorCard="#0F172A" title="" v-if="!mantenimiento">
      <v-col cols="12" class="pa-0 main-container-glass">
        <!-- Top Bar -->
        <div class="prism-top-bar d-flex align-center justify-space-between px-8 py-5">
           <div class="d-flex align-center">
            <v-btn
              icon
              @click="$router.push({ name: 'Home' })"
              class="mr-4 glass-btn"
              large
              v-if="user && user.IDStB"
            >
              <v-icon color="primary">mdi-arrow-left-circle-outline</v-icon>
            </v-btn>
             <div>
              <h1 class="text-h6 font-weight-black prism-title mb-0">Efectuar Pago</h1>
              <div class="text-caption grey--text font-weight-medium">Gestión de Aranceles Académicos</div>
            </div>
           </div>
        </div>

        <v-divider class="prism-divider"></v-divider>

        <v-row class="pa-8">
          <!-- Selection & Alerts Layer -->
          <v-col cols="12" lg="5">
            <div class="sticky-card">
                            <!-- Qobra Alert -->
              <v-alert dense text color="blue-grey darken-3" class="rounded-xl mb-4 bg-white" icon="mdi-information-outline">
                  <div class="text-caption">Los pagos realizados con <strong>Qobra</strong> pueden demorar unos minutos en acreditarse.</div>
              </v-alert>
              <!-- Subscription Alerts -->
              <v-alert v-show="isSuscribedDA" text color="amber darken-4" class="rounded-xl border-amber mb-6" icon="mdi-shield-check">
                  <div class="text-body-2 font-weight-bold">Suscripción Activa</div>
                  <div class="text-caption">Usted está adherido al débito automático en <strong>Mercado Pago</strong>.</div>
              </v-alert>
              <v-alert v-show="isSuscribedMB" text color="amber darken-4" class="rounded-xl border-amber mb-6" icon="mdi-shield-check">
                  <div class="text-body-2 font-weight-bold">Suscripción Activa</div>
                  <div class="text-caption">Usted está adherido al débito automático en <strong>Mobbex</strong>.</div>
              </v-alert>

              <v-card flat class="pa-8 rounded-xl glass-card-heavy mb-8">
                <div class="d-flex align-center mb-6">
                  <div class="elite-icon-box mr-4">
                      <v-icon color="primary">mdi-school-outline</v-icon>
                  </div>
                  <div>
                      <h2 class="text-h6 font-weight-black prism-heading">Selección de Curso</h2>
                      <p class="text-caption grey--text mb-0">Elija el programa para ver sus cuotas</p>
                  </div>
                </div>

                <div class="text-overline font-weight-black mb-2 primary--text">Curso / Programa</div>
                <v-select
                  v-model="curso"
                  :items="cursos"
                  :item-text="item => item.cruso_data ? (item.cruso_data.Feriado || item.cruso_data.nombre) : 'Curso'"
                  item-value="cruso_data.IDF"
                  placeholder="Seleccione un programa académico"
                  outlined
                  flat
                  persistent-hint
                  return-object
                  single-line
                  @change="loadData"
                  class="rounded-xl elite-input mb-4"
                  hide-details
                ></v-select>

                <!-- Summary Total Display -->
                <div v-if="curso" class="elite-total-box pa-6 rounded-xl mt-8">
                   <div class="d-flex justify-space-between align-center mb-2">
                      <span class="text-caption font-weight-bold grey--text uppercase">Total a Procesar</span>
                      <v-chip v-if="total > 0" small color="success" class="font-weight-black px-4">${{ total }}</v-chip>
                   </div>
                   <div class="text-h4 font-weight-black primary--text mb-6">
                      ${{ total }} <span class="text-caption grey--text">ARS</span>
                   </div>

                   <v-btn
                    block
                    color="primary"
                    x-large
                    depressed
                    class="rounded-xl font-weight-black letter-spaced"
                    @click="pay()"
                    :disabled="total == 0"
                  >
                    CONFIRMAR PAGO
                  </v-btn>
                </div>
              </v-card>
            </div>
          </v-col>

          <!-- Payments List -->
          <v-col cols="12" lg="7">
             <div v-if="curso">
                <div class="d-flex align-center justify-space-between mb-6">
                   <h2 class="text-h5 font-weight-black prism-heading">Estructura de Cuotas</h2>
                   <div class="d-flex" v-if="pagos.items">
                      <v-chip small color="primary" class="mr-2" outlined>{{ pagos.items.length }} ÍTEMS</v-chip>
                   </div>
                </div>

                <div class="payments-viewport">
                   <div v-for="(pagoData, pagoKey) in pagos.items" :key="pagoKey">
                      <v-card 
                        flat 
                        :class="['rounded-xl mb-4 transition-all overflow-hidden', 
                               pagoData.pagado ? 'glass-card-light' : 'glass-card-interactive',
                               pagoData.block ? 'locked-item' : '']"
                      >
                         <div class="pa-6 d-flex align-center">
                            <v-checkbox 
                              v-if="canPay(pagoData)" 
                              v-model="pagoData.check" 
                              @change="changeTotal(pagoData, pagoKey)"
                              color="primary"
                              class="mr-4 mt-0"
                              hide-details
                            ></v-checkbox>
                            
                            <v-avatar v-else size="40" :color="pagoData.pagado ? 'success lighten-5' : 'grey lighten-4'" class="mr-4">
                               <v-icon :color="pagoData.pagado ? 'success' : 'grey'" small>
                                 {{ pagoData.pagado ? 'mdi-check-circle' : 'mdi-lock-outline' }}
                               </v-icon>
                            </v-avatar>

                            <div class="flex-grow-1">
                               <div class="d-flex justify-space-between align-start">
                                  <div>
                                     <div class="text-subtitle-1 font-weight-black mb-1">{{ pagoData.Materia }}</div>
                                     <div class="d-flex align-center">
                                         <span class="text-h6 font-weight-black mr-3" :class="pagoData.pagado ? 'success--text' : 'primary--text'">
                                            ${{ pagoData.pagado ? pagoData.precioPagado : pagoData.precioAPagar }}
                                         </span>
                                         <v-chip v-if="pagoData.beca != 0" x-small color="green" dark class="font-weight-black">
                                           BECA {{ pagoData.beca }}%
                                         </v-chip>
                                     </div>
                                  </div>

                                  <div class="text-right">
                                     <v-chip 
                                      x-small 
                                      :color="pagoData.pagado ? 'success' : (pagoData.block ? 'grey' : 'primary')" 
                                      class="font-weight-black mb-1" 
                                      dark
                                     >
                                       {{ pagoData.pagado ? 'PAGADO' : (pagoData.block ? 'BLOQUEADO' : 'PENDIENTE') }}
                                     </v-chip>
                                      <div v-if="pagoData.block && !pagoData.pagado" class="text-tiny grey--text font-weight-medium">
                                        Requiere cuota anterior
                                      </div>
                                  </div>
                               </div>
                            </div>
                         </div>
                      </v-card>
                   </div>

                   <!-- Platform Fee Card -->
                   <v-card flat class="rounded-xl glass-card-light overflow-hidden pa-4 border-dashed mb-16">
                      <div class="d-flex justify-space-between align-center">
                         <div class="d-flex align-center">
                            <v-icon color="grey darken-1" class="mr-3">mdi-shield-lightning-outline</v-icon>
                            <span class="text-caption font-weight-black grey--text text--darken-2">COMISIÓN DE PLATAFORMA</span>
                         </div>
                         <v-chip x-small color="grey darken-3" dark class="font-weight-black">BONIFICADO 0%</v-chip>
                      </div>
                   </v-card>
                </div>
             </div>

             <!-- Placeholder when no course selected -->
             <div v-else class="text-center py-16 glass-card-light rounded-xl mt-10">
                <v-icon size="64" color="grey lighten-3">mdi-credit-card-search-outline</v-icon>
                <div class="grey--text mt-4 font-weight-medium">Seleccione un curso para ver el plan de pagos.</div>
             </div>
          </v-col>
        </v-row>
      </v-col>
    </CardIeaAppMain>

    <!-- Maintenance View -->
    <CardIeaAppMain colorCard="#0F172A" title="" v-else>
      <v-col cols="12" class="main-container-glass py-16 px-8 text-center fill-height d-flex flex-column justify-center align-center">
        <div class="elite-icon-box mx-auto mb-6" style="width: 80px; height: 80px;">
            <v-icon color="error" size="40">mdi-alert-octagon-outline</v-icon>
        </div>
        <h2 class="text-h4 font-weight-black primary--text mb-4">Servicio en Mantenimiento</h2>
        <p class="text-body-1 grey--text text--darken-2 max-w-md mx-auto mb-8">
          Estamos actualizando nuestra pasarela de pagos para brindarte una mejor experiencia. 
          Vuelve a intentarlo en unos minutos.
        </p>
        <v-btn
          color="primary"
          large
          depressed
          class="rounded-xl px-12"
          @click="$router.push({ name: 'Home' })"
        >
          VOLVER AL INICIO
        </v-btn>
        
        <v-text-field
          v-model="isadmin"
          label="Password de acceso"
          dense
          outlined
          @input="up"
          class="mt-16 opacity-30"
          style="max-width: 200px;"
          type="password"
        ></v-text-field>
      </v-col>
    </CardIeaAppMain>
  </div>
</template>


<script>
// import CardIeaApp from "../../components/CardIeaApp";
import CardIeaAppMain from "../../components/CardIeaAppMain";


export default {
  name: "PaymentCurso",
  components: {
    // CardIeaApp,
    CardIeaAppMain,


  },

  data: function() {
    return {
      title:"Efectuar pago",
      curso: null,
      cursos:[],
      pagos:[],
      total:0,
      items:[],
      urlPay : '',
      mantenimiento:false,
      isadmin:'',
      isSuscribedDA : false,
      isSuscribedMB:false
    }
  },
  computed: {
    user() {
      return this.$store.getters.user;
    }
  },
  mounted() {

    this.getIsSuscribedToDA();

    this.$API
      .get({
        url: "alumno/cursos",
        data: {},
      })
      .then((res) => {
        this.cursos = res;
      })
      .catch((err) => {
        console.log(err);
    });
  },

  methods: {
    handleEventClick(clickInfo) {
      let datos = clickInfo.event.extendedProps
      console.log(this.$refs.calendar)

      if(datos.turno_id && !datos.block){
        this.dialog = true
        this.turno_id = datos.turno_id;
      }
    },
    up (){
      if (this.isadmin == 'adminadmin') {
        this.mantenimiento = false;
      }
    },

    getIsSuscribedToDA() {

      this.$API
        .get({
          url: "mp-getsuscription-status/" + this.user.IDStB,
          data: {},
        })
        .then((res) => {
          console.log(res)
          this.isSuscribedDA = res.isSuscribedMP;
          this.isSuscribedMB=res.isSuscribedMB;
        })
        .catch((err) => {
          console.log(err);
      });

    },

    async loadData() {
      console.log(this.curso.Curso)
      this.$API
        .get({
          url: "listado-pagos/" + this.curso.Curso,
          data: {},
        })
        .then((res) => {
          console.log(res)
          //let r = res.items.map((value) => {return {...value, precioAPagarDesc:value.precioAPagar - ((value.precioAPagar * res.descuento)/100)}})
          //res.items = r;
          this.pagos = res;
          this.total = 0;
        })
        .catch((err) => {
          console.log(err);
      });
    },

    colorText(pagoData) {
      let color = 'black';
      if(pagoData.block){
        color = '#888';
      }
      if(pagoData.pagado){
        color = 'green';
      }
      return {color:color}
    },

    canPay(pagoData) {
      return (!pagoData.block && !pagoData.pagado) ? true : false;
    },
    changeTotal(pagoData, index) {
      console.log(pagoData)
      pagoData.index = index;
      if(pagoData.check){
        this.total += parseFloat(pagoData.precioAPagar)
      }else{
        this.total -= parseFloat(pagoData.precioAPagar);
      }
      let selecteds = this.pagos.items.filter(d => {return d.check;})
      this.items = selecteds.map((value) => {return {id: value.IDStB, monto: value.precioAPagarDesc, index:value.index }})
      console.log(this.items)
    },

    async pay() {
      let dataSend = {
        curso  : this.curso.Curso,
        alumno : this.user.IDStB,
        items  : this.items,
        sede : (this.curso && this.curso.cruso_data && this.curso.cruso_data.sede) ? (this.curso.cruso_data.sede.razonSocial || this.curso.cruso_data.sede.Feriado || "") : "",
      };

      // MP
      // let url = "plan-de-pago/pagar";

      // await this.$API
      //   .post({
      //     url: url,
      //     data: dataSend
      //   }).then((res) => {
      //     this.urlPay = res;

      //     location.href = res

      //   });

      // Mobbex
      let url = "mobbex/generar-link-pago-materias";

      await this.$API
        .post({
          url: url,
          data: dataSend
        }).then((res) => {
          // this.urlPay = res;
          if(res.error){
            alert(res.error)
            return false
          }
          location.href = res.data.url
        });



    }
  }
};
</script>
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Outfit:wght@700;900&display=swap");

.prism-elite-app {
  font-family: "Inter", sans-serif !important;
  background: radial-gradient(circle at 100% 100%, #0f172a 0%, #1a237e 100%);
  min-height: 100vh;
}

h1, h2, h3, .prism-heading, .text-overline {
  font-family: "Outfit", sans-serif !important;
  letter-spacing: -0.5px;
}

.main-container-glass {
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(20px);
  min-height: 90vh;
}

.prism-top-bar { background: transparent; }
.prism-divider { border-color: rgba(0,0,0,0.05) !important; }

/* Elite Cards */
.glass-card-heavy {
  background: white;
  box-shadow: 0 10px 30px -10px rgba(0, 0, 0, 0.05) !important;
  border: 1px solid rgba(0,0,0,0.05) !important;
}

.glass-card-interactive {
  background: white;
  border: 1px solid #f1f5f9 !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.glass-card-interactive:hover {
  transform: scale(1.01);
  box-shadow: 0 20px 40px -15px rgba(0, 0, 0, 0.1) !important;
  border-color: #e2e8f0 !important;
}

.glass-card-light {
   background: #f8fafc !important;
   border: 1px solid #e2e8f0 !important;
}

.locked-item {
  opacity: 0.7;
  background: #f1f5f9 !important;
}

/* Elite Form Inputs */
.elite-input ::v-deep fieldset {
  border-color: rgba(0,0,0,0.08) !important;
  transition: border-color 0.3s;
}
.elite-input:hover ::v-deep fieldset {
  border-color: rgba(0,0,0,0.15) !important;
}
.elite-input.v-input--is-focused ::v-deep fieldset {
  border-color: #1a237e !important;
  border-width: 2px;
}

/* Total Box */
.elite-total-box {
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
}

/* Icon Box */
.elite-icon-box {
  width: 50px;
  height: 50px;
  background: #f1f5f9;
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.border-s {
  border-left: 4px solid #1a237e;
}
.border-accent {
  border-left: 4px solid #10b981;
}
.border-amber {
  border: 1px solid #ffb300 !important;
}

.border-dashed {
  border: 1px dashed #cbd5e1 !important;
}

.letter-spaced {
  letter-spacing: 1px !important;
}

.uppercase { text-transform: uppercase; }
.text-tiny { font-size: 0.75rem !important; }

.border-top {
  border-top: 1px solid #e2e8f0;
}

.payments-viewport {
  max-height: 700px;
  overflow-y: auto;
  padding-right: 12px;
}
.payments-viewport::-webkit-scrollbar {
  width: 6px;
}
.payments-viewport::-webkit-scrollbar-thumb {
  background: #e2e8f0;
  border-radius: 10px;
}

@media (min-width: 1264px) {
  .sticky-card {
    position: sticky;
    top: 24px;
  }
}

.transition-all {
  transition: all 0.3s ease;
}

.max-w-md { max-width: 448px; }
.opacity-30 { opacity: 0.3; }
</style>
